<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="Yetki" class="float-right">
        <el-button type="info" size="small" class="YeniBtn" @click="this.YeniBtn">{{ Sayfa.ButtonAdi }}
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-table
        v-if="Liste"
        :data="Liste.filter(data => !search || data.Adi.toLowerCase().includes(search.toLowerCase()))"
        :default-sort="{prop: 'Adi', order: 'ascending'}"
        class="alttable"
        row-key="id"
        :height="Height"
        default-expand-all>
        <el-table-column
          prop="Kod"
          label="Kod"
          width="180">
        </el-table-column>
        <el-table-column
          prop="Adi"
          label="Adi">
        </el-table-column>
        <el-table-column
          prop="DemirbasText"
          label="Demirbaş"
          width="100">
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="medium"
              :placeholder="Sayfa.Arama"/>
          </template>
          <template slot-scope="scope">
            <el-button-group>
              <el-tooltip v-if="Yetki" class="item" effect="dark" content="Hareketleri Devret"
                          placement="top-start">
                <i
                  class="feather-shuffle tableibtn text-warning"
                  @click="HareketDevret(scope.row)">
                </i>
              </el-tooltip>
              <el-tooltip v-if="Yetki" class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <i
                  class="feather-edit-2 tableibtn text-primary"
                  @click="DuzenleBtn(scope.row)">
                </i>
              </el-tooltip>
              <el-tooltip v-if="Yetki" class="item" effect="dark"
                          :content="Sayfa.SilAdi"
                          placement="top-start">
                <i
                  class="feather-trash tableibtn text-danger"
                  @click="SilOnay(scope.row.id)">
                </i>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      v-if="HareketDevirModal"
      title="Kategori Hareket Devir İşlemi"
      :visible="HareketDevirModal"
      center
      width="30%">
      <a @click="HareketDevirModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>

      <el-form :model="DevirFormData" @submit.prevent.native="Submit" :rules="DevirFormHata" ref="HareketForm">

        <el-form-item label="Hareketleri Devir Alacak Kategori" prop="dKategori_id">
          <el-cascader
            v-model="DevirFormData.dKategori_id"
            collapse-tags
            placeholder="Kategori Seçiniz"
            :props="{ multiple: false}"
            :options="Liste"
            filterable></el-cascader>
        </el-form-item>

      </el-form>
      <el-alert
        title="Önemli Bilgilendirme"
        type="warning"
        :closable="false"
        :description="HareketSecim.Adi+' Kategorisindeki bütün hareketler aşağıda seçtiğiniz kategoriye devredilecek ve silinecektir.'"
      >
      </el-alert>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" :loading="lo" size="medium" @click="HareketDevirOnay()" icon="el-icon-check">
          Devret ve <b>{{ HareketSecim.Adi }}</b> Kategorisini sil
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="Baslik"
      :visible="ModalOlayi"
      center
      width="50%">
      <Yukleniyor :data="lo"></Yukleniyor>
      <a @click="ModalOlayi=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form :model="FormData" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="Üst Kategori" prop="Kategori_id">
              <el-select v-model="FormData.Kategori_id" filterable clearable>
                <el-option
                  v-for="item in Liste"
                  :key="item.id"
                  :label="item.Kod+' '+item.Adi"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Kategori Kodu" prop="Kod">
              <el-input v-model="FormData.Kod"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Kategori Adı" prop="Adi">
              <el-input v-model="FormData.Adi"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="Tooltip" label="Demirbaş" prop="Demirbas">
              <el-tooltip class="item" effect="dark"
                          content="Kategorideki borçları sadece mesken sahipleri ödeyecekse açınız"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-switch v-model="FormData.Demirbas"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="$store.getters.Paket==1">
            <el-form-item class="Tooltip" label="Şirket" prop="sGelir">
              <el-tooltip class="item" effect="dark" content="Şirket gelir"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-switch v-model="FormData.sGelir"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="Submit()" icon="el-icon-check">
          {{ $t('eGenel.0') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Yukleniyor from "../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      lo: false,
      Yetki: false,
      ModalOlayi: false,
      HareketDevirModal: false,
      Baslik: null,
      search: '',
      Height: window.innerHeight - 150,
      Sayfa: {
        ButtonAdi: 'Kategori Ekle',
        DuzenleAdi: this.$t('eGenel.10'),
        SilAdi: this.$t('eGenel.11'),
        Button: null,
        EkranAdi: 'Kategori Detay',
        Adi: 'Kategori Listesi',
        Menu: [],
        MenuDisplay: null,
      },
      Liste: [],
      FormHata: {
        Adi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
      },
      FormData: {},
      DevirFormHata: {
        dKategori_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
      },
      DevirFormData: {
        dKategori_id: null,
        Kategori_id: null
      },
    }
  },
  methods: {
    HareketDevret(Kategori) {
      this.HareketDevirModal = true
      this.HareketSecim = Kategori
      this.DevirFormData.Kategori_id = Kategori.id
      this.DevirFormData.dKategori_id = null
    },
    HareketDevirOnay() {
      this.$refs['HareketForm'].validate((valid) => {
        if (valid) {
          this.$confirm("Bu işlem hiç bir şekilde geri alınamayacaktır. Kategori hareketlerinin devir edilmesini onaylıyormusunuz?", this.$t('eGenel.7'), {
            confirmButtonText: this.$t('eGenel.2'),
            cancelButtonText: this.$t('eGenel.3'),
            type: 'warning'
          }).then(() => {
            this.DevirBaslat()
          }).catch(() => {
            this.$message.info(this.$t('eGenel.8'));
          });
        }
      });
    },
    DevirBaslat() {
      this.$store.dispatch("Post", {
        ...this.DevirFormData,
        path: 'muhasebe/hareketdevir/kategori'
      })
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.SayfaYukle()
            this.$message.success(response.Mesaj);
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    Submit() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true;
          if (this.FormData.id) {
            // DÜZENLE
            this.$store.dispatch("Put", {
              ...this.FormData,
              path: 'muhasebe/kategori/' + this.FormData.id
            })
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.SayfaYukle()
                  this.$message.success(response.Mesaj);
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })

          } else {
            // EKLE
            this.$store.dispatch("Post", {...this.FormData, path: 'muhasebe/kategori'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.SayfaYukle()
                  this.$message.success(response.Mesaj);
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        }
      });
    },
    SayfaYukle() {
      this.ModalOlayi = false;
      this.HareketDevirModal = false;
      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Liste = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.Yetki = this.$store.getters.Yetki.muhasebe == 2 ? true : false;

    },
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.lo = true;
      this.$store.dispatch("Delete", {...this.Form, path: 'muhasebe/kategori/' + id})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    YeniBtn() {
      this.ModalOlayi = true;
      this.Baslik = 'Kategori Ekle';
      this.FormData = {
        Kategori_id: null,
        Adi: null,
        Kod: null,
        Demribas: false,
        sGelir: false,
      }
    },
    DuzenleBtn(Veri) {
      // console.log(Veri);
      this.FormData = Veri;
      this.Baslik = Veri.Adi + ' Düzenle';
      this.ModalOlayi = true
    },
  },
  created() {
    this.$store.commit("SayfaBilgi", this.Sayfa);
    //console.log(this.Sayfa);
    this.SayfaYukle();

  }

}
</script>



// WEBPACK FOOTER //
// src/pages/Muhasebe/kategori.vue